import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { login, findPassword } from '../services/authService';
import './LoginPage.css';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [mode, setMode] = useState('login'); // 'login', 'findPassword'
  const [findEmail, setFindEmail] = useState('');
  const [message, setMessage] = useState('');
  const [welcomeUser, setWelcomeUser] = useState(null);
  const [showWelcomeModal, setShowWelcomeModal] = useState(false);

  const { login: setAuth } = useAuth();
  const navigate = useNavigate();

  const getPostLoginRoute = (user) => (user?.status === 'submitted' ? '/completed' : '/consent');

  const openWelcomeModal = (user) => {
    setWelcomeUser(user);
    setShowWelcomeModal(true);
  };

  const handleWelcomeConfirm = () => {
    if (!welcomeUser) return;
    const key = `welcome_shown_${welcomeUser.id}`;
    localStorage.setItem(key, '1');
    setShowWelcomeModal(false);
    navigate(getPostLoginRoute(welcomeUser));
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await login(email, password);
      setAuth(response.user);
      // 관리자인지 확인하여 적절한 페이지로 리다이렉트
      if (response.user.is_admin || response.user.is_staff) {
        navigate('/admin/members');
      } else {
        const key = `welcome_shown_${response.user.id}`;
        if (localStorage.getItem(key)) {
          navigate(getPostLoginRoute(response.user));
        } else {
          openWelcomeModal(response.user);
        }
      }
    } catch (err) {
      setError(err.response?.data?.message || '로그인에 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };

  const handleFindPassword = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);

    try {
      await findPassword(findEmail);
      setMessage('이메일로 임시 비밀번호를 발급했습니다.');
      setFindEmail('');
    } catch (err) {
      setError(err.response?.data?.message || '비밀번호 찾기에 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <h1>BnH 세무법인</h1>
        
        <div className="mode-tabs">
          <button
            className={mode === 'login' ? 'active' : ''}
            onClick={() => setMode('login')}
          >
            로그인
          </button>
          <button
            className={mode === 'findPassword' ? 'active' : ''}
            onClick={() => setMode('findPassword')}
          >
            비밀번호 찾기
          </button>
        </div>

        {mode === 'login' && (
          <form onSubmit={handleLogin} className="login-form">
            <div className="form-group">
              <label htmlFor="email">이메일</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="이메일을 입력하세요"
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">비밀번호</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="비밀번호를 입력하세요"
              />
            </div>
            {error && <div className="error-message">{error}</div>}
            <button type="submit" className="submit-btn" disabled={loading}>
              {loading ? '로그인 중...' : '로그인'}
            </button>
          </form>
        )}

        {mode === 'findPassword' && (
          <form onSubmit={handleFindPassword} className="login-form">
            <div className="form-group">
              <label htmlFor="findEmail">이메일</label>
              <input
                type="email"
                id="findEmail"
                value={findEmail}
                onChange={(e) => setFindEmail(e.target.value)}
                required
                placeholder="가입 시 사용한 이메일을 입력하세요"
              />
            </div>
            {error && <div className="error-message">{error}</div>}
            {message && <div className="success-message">{message}</div>}
            <button type="submit" className="submit-btn" disabled={loading}>
              {loading ? '처리 중...' : '비밀번호 찾기'}
            </button>
          </form>
        )}
      </div>

      {showWelcomeModal && (
        <div className="welcome-modal-overlay">
          <div className="welcome-modal">
            <div className="welcome-modal-content">
              <p>고객사명: {welcomeUser?.company || ''}</p>
              <p>납세자명: {welcomeUser?.name || ''}</p>
              <p className="welcome-message">접속을 환영합니다</p>
            </div>
            <button className="welcome-confirm-btn" onClick={handleWelcomeConfirm}>
              확인
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoginPage;

